module.exports = __webpack_public_path__ + "static/media/SidebarIcon.6cc6d941.svg";